module.exports = __webpack_public_path__ + "img/background-panel-hello.653253e2.svg";